export default __webpack_public_path__ + "static/media/video-devices.b27bb59e.m4v";